module.exports = __webpack_public_path__ + "img/no_image.9430579c.jpg";